export default "__VITE_ASSET__DaEAZh7t__"